import React from 'react'

import {AcceptedForm} from '../templates';
import {PageTemplate} from '../atoms';

export default function AcceptedPage({history}) {
  const {language} = history.location.state;
  return (
    <PageTemplate>
      <AcceptedForm language={language}/>
    </PageTemplate>
  )
}
